import { alert } from "@cems-eco/core/src/utils/widget";
import router from "@/router";
import { Subscription } from "rxjs";
import { IAccessStorage, IAuthStorage, IAlarmStorage } from "../storage/model";
import storage from "@/storage";
import { User } from "@/modules/maintenance/services";
export abstract class GuardService {
  async isAuthenticated(): Promise<boolean> {
    const auth = await storage.get<IAuthStorage>(storage.AUTH);
    return auth != null;
  }

  async logout() {
    router.replace("/");
    await storage.clearAll();
  }

  async pageAccess(to, from, next) {
    try {
      const permissionName = to.meta?.permissionName;

      if (!(await this.isAuthenticated())) {
        alert(
          "Access Denied",
          "You are not authenticated. Please Login",
          "error"
        );
        return next("/");
      }

      if (permissionName && !this.hasPermission([permissionName], true)) {
        return next(false);
      }

      return next();
    } catch (e) {
      console.log(e);
      return next("/");
    }
  }

  isSuperadmin(user: User | null = null) {
    if (!user) {
      user = storage.getSync<User>(storage.USER);
    }
    return user.role == "Superadmin";
  }

  hasPermission(permissionNames: any[], showAlert = false) {
    if (this.isSuperadmin()) return true;
    const permissions = storage.getSync<string[]>(storage.PERMISSION);
    const filtered = permissions.filter((permission) =>
      permissionNames.includes(permission)
    );

    if (showAlert && !(filtered.length > 0)) {
      alert(
        "Action Denied",
        `You dont have permission to perform this action. You must have at least one of the following: ${this.listPermissions(
          permissionNames
        )}`,
        "error"
      );
    }
    return filtered.length > 0;
  }

  mustHasPermission(permissionNames: any[], showAlert = false) {
    if (this.isSuperadmin()) return true;
    const permissions = storage.getSync<string[]>(storage.PERMISSION);
    const filtered = permissions.filter((permission) =>
      permissionNames.includes(permission)
    );

    if (showAlert && !(filtered.length == permissionNames.length)) {
      alert(
        "Action Denied",
        `You dont have permission to perform this action. You must have all of the following: ${this.listPermissions(
          permissionNames
        )}`,
        "error"
      );
    }
    return filtered.length == permissionNames.length;
  }

  private listPermissions(perms) {
    if (!Array.isArray(perms)) return "";
    const len = perms.length;

    if (len === 0) return "";
    if (len === 1) return perms[0];
    if (len === 2) return `${perms[0]} and ${perms[1]}`;

    return perms.slice(0, -1).join(", ") + ", and " + perms[len - 1];
  }

  abstract checkAuthentication();
  abstract checkProviderStatus();
}
